export const EN = {
  // Navigation & Menu
  nav_home: "Home",
  nav_about: "About",
  nav_roadmap: "Roadmap",
  nav_showcase: "Reviews", 
  nav_service: "Service",
  nav_blog: "Blog", 
  nav_faq: "FAQ", 
  nav_insurance: "Insurance",
  nav_contact: "Contact", 
  btn_contact_us: "Contact Us",
  btn_explore: "Explore",
  read_more: "Read More",

  // Home Section
  home_pain_q: "Got PAIN?",
  home_pain_chronic: "Chronic Pain",
  home_pain_sports: "Sports Injury",
  home_pain_post_surgery: "Post-Surgery Rehab",
  home_pain_other: "other Conditions",
  home_subtitle: "Let's fix it together.",
  
  // About Section - UPDATED TO 4 SEPARATE PARAGRAPHS
  about_title: "Welcome To Function in Motion Physical Therapy PC",
  about_text_1: "You’ve endured the agony—the endless hunt for relief that slipped away, feeling like just another faceless patient in rushed, broken promises. We see you. We feel your despair. You’re not alone.",
  about_text_2: "At Function in Motion Physical Therapy, we don’t fix injuries—we resurrect you. The fighter behind the pain, the dreams crushed by doubt, the life screaming to break free. We’ve walked this fire with warriors like you, proving healing isn’t a myth.",
  about_text_3: "Here, your story ignites our fight. We craft unbreakable plans that honor your scars and fuel your fire—not Band-Aids, but a relentless path to reclaim hope, shatter limits, and unleash the unbreakable force within.",
  about_text_4: "This is Function in Motion: Where pain bows to power. Where motion becomes mastery. Your triumph starts now.",
  
  // Roadmap/Process Section
  roadmap_title: "Roadmap",
  roadmap_1_title: "ASSESSMENT",
  roadmap_1_text: "We start by listening to your story and understanding what's really going on. Through a comprehensive evaluation, we identify the root cause of your pain or limitation—not just the symptoms.",
  roadmap_2_title: "INDIVIDUALIZED CARE PLAN/GOAL SETTING",
  roadmap_2_text: "Together, we establish clear, realistic and attainable goals that matter to you. Then we create a personalized plan that fits your lifestyle, age, physical limitations, strengths, and schedule to help you reach those goals.",
  roadmap_3_title: "COLLABORATION",
  roadmap_3_text: "Together, we'll execute your plan. Your therapist provides the tools and knowledge, but real rehabilitation happens at home—where you put what you've learned into practice. We guide you, but your commitment is what makes the difference.",
  roadmap_4_title: "PROGRESS MONITORING",
  roadmap_4_text: "Recovery isn't linear, and we get that. We regularly evaluate how you're progressing, celebrate the wins, and adjust your plan when needed. If something isn't working, we pivot. If you're crushing your goals, we raise the bar. We stay flexible and responsive because your body and your journey are unique.",
  roadmap_5_title: "EVALUATION",
  roadmap_5_text: "We evaluate whether the goals we set together have been achieved. If they haven't been met, we'll create a new plan to get you there. If they have, congratulations—you've earned it. This checkpoint ensures you're either ready to move forward or equipped with a clear path to continue progressing.",
  roadmap_6_title: "ONGOING SUPPORT & PREVENTION",
  roadmap_6_text: "Before you leave, we equip you with the knowledge and tools to maintain your progress and prevent future injuries. And if you ever need us again, we're just a call away.",
  
  // Team/Services Section
  title_what_we_do: "What We Do",
  service_1_title: "Post-Surgical Rehab",
  service_1_text: "Recover stronger after surgery",
  service_2_title: "Sports Injury Rehab",
  service_2_text: "Back to your sport, safely",
  service_3_title: "Chronic Pain Management",
  service_3_text: "Move beyond just coping",
  service_4_title: "Stemwave Shockwave Therapy",
  service_4_text: "For stubborn tendon and soft-tissue pain",
  service_5_title: "Alter-G Antigravity Treadmill",
  service_5_text: "Low-impact return to walking and running",
  service_6_title: "Gait & Balance Training",
  service_6_text: "Improve stability and prevent falls",
  service_7_title: "Performance & Return to Sport",
  service_7_text: "Train to perform, not just to heal",
  service_8_title: "Spine & Posture Rehab",
  service_8_text: "Neck, back, and core-focused care",
  service_9_title: "Work-Related Injury Rehab",
  service_9_text: "Get back to work safely and stronger",
  
  // Showcase/Review Section
  title_what_they_say: "What They Say About Us",
  reviewed_by: "Reviewed by",
  rating: "Rating",
  review_1_text: "Vic and his staff have been a blessing during this difficult time. I am recovering from a left tibia plateau fracture. I've seen immense progress. I know that I will continue improving thanks to the attention and care the staff have given me.",
  review_5_text: 'I\'ve been doing Physical Therapy for a year and a half because I have Limited Mobility with no results. I decided to try Function In Motion and didn\'t regret my choice. Thanks to Vic and his caring, considerate, awesome staff my Mobility has improved considerably. They are really True to their name "Function In Motion".',
  review_6_text: "Hi my name is Carolyn, and I would just like to say I was so amaze how polite and caring Vic and his staff are to his clients . He take time answer all your questions and concerns yes I would highly recommend anyone who is interested in finding a good physical therapist to come to function in motion and they would be more than satisfied!!",
  review_10_text: "They do their best to accommodate your needs and make you feel seen and supported at every visit.",
  
  // FAQ Section
  faq_heading: "FAQ",
  faq_referral_q: "Do I need a referral from my provider?",
  faq_referral_a: "Yes. A referral is required unless your insurance is HIP, GHI, or you are paying for the visit yourself. If you’re not sure what your plan requires, we can help you confirm before your first appointment.",
  faq_sessions_q: "How long are the sessions?",
  faq_sessions_a: "Sessions typically last 45–60 minutes, giving us real time to work with you one-on-one and address what’s going on.",
  faq_first_visit_expect_q: "What should I expect at my first physical therapy appointment?",
  faq_first_visit_expect_a: "Your therapist will take your medical history, discuss your symptoms, perform a physical evaluation, and create a personalized treatment plan. You may also receive your first treatment the same day.",
  faq_hurt_q: "Will physical therapy hurt?",
  faq_hurt_a: "Some discomfort during treatment is normal—healing isn’t always easy. But we’ll never push you beyond what’s safe or productive. We’re here to help you heal, not make things worse.",
  faq_insurance_q: "Will my insurance cover this?",
  faq_insurance_a: "Most insurance plans cover physical therapy, but coverage varies. We’ll help you understand your benefits and work with you on payment options.",
  faq_bring_first_q: "What should I bring to my first visit?",
  faq_bring_first_a: "A referral (unless your insurance is HIP, GHI, or you are paying for the visit yourself), your insurance card, photo ID, medication list, any relevant medical records or imaging reports, and comfortable clothing.",
  faq_cancel_q: "What if I need to cancel my appointment?",
  faq_cancel_a: "Please let us know as early as you can if you can’t make it. This allows us to give your appointment time to another patient in need.",
  faq_pain_return_q: "What if my pain comes back after treatment?",
  faq_pain_return_a: "We don’t just fix the problem—we teach you how to prevent it from happening again. And if something does flare up down the road, we’re always here.",
  faq_exercises_q: "Do I need to keep doing exercises after therapy ends?",
  faq_exercises_a: "Yes. The exercises and habits we build together aren’t just for recovery—they’re for keeping you strong and pain-free long-term. We’ll give you a maintenance plan that’s realistic and sustainable for your life.",

  // Contact Form Section
  contact_heading: "Leave a Message",
  contact_subtitle: "Have a question about your condition or insurance? Send us a quick message and we'll get back to you as soon as possible.",
  contact_name_label: "Your Name",
  contact_email_label: "Your Email",
  contact_message_label: "Your Message",
  contact_send_btn: "Send Message",
  contact_success_message: "Thank you for your message! We will be in touch shortly.",
  contact_error_message: "Oops! There was an issue submitting your form.",
  
  // Insurance Section
  title_insurances_accepted: "Insurances Accepted",
  insurance_subtitle: "We work with major insurance providers so your patients can focus on healing, not paperwork.",
  
  // Footer & Banner
  banner_title_1: "	Function in Motion: Conquer pain. Command motion. Dominate life.",
  banner_title_2: "Join Us!",
  footer_phone: "Phone:",
  footer_hours: "Hours",
  footer_hours_mf: "Mon–Fri: 8:30am – 5:00pm",
  footer_hours_sat: "Sat: 8:30am – 12:00pm",
  footer_hours_sun: "Sun: Closed",
  footer_all_rights_reserved: "All rights reserved.",
  footer_made_by: "Made with ❤️ by",
};

export const ES = {
  // Navigation & Menu
  nav_home: "Inicio",
  nav_about: "Sobre Nosotros",
  nav_roadmap: "Hoja de Ruta",
  nav_showcase: "Testimonios", 
  nav_service: "Servicio",
  nav_blog: "Blog",
  nav_faq: "Preguntas Frecuentes",
  nav_insurance: "Seguros",
  nav_contact: "Contacto", 
  btn_contact_us: "Contáctenos",
  btn_explore: "Explorar",
  read_more: "Leer Más",

  // Home Section
  home_pain_q: "¿Tiene DOLOR?",
  home_pain_chronic: "Dolor Crónico",
  home_pain_sports: "Lesión Deportiva",
  home_pain_post_surgery: "Rehabilitación Post-Cirugía",
  home_pain_other: "otras Afecciones",
  home_subtitle: "Arreglémoslo juntos.",

  // About Section - UPDATED TO 4 SEPARATE PARAGRAPHS
  about_title: "Bienvenido a Function in Motion Physical Therapy PC",
  about_text_1: "Has soportado la agonía—la búsqueda interminable de alivio que se escapa, sintiéndote solo otro paciente sin rostro en sesiones apresuradas y promesas rotas. Te vemos. Sentimos tu desesperación. No estás solo.",
  about_text_3: "AquAquí, tu historia enciende nuestra batalla. Forjamos planes inquebrantables que honran tus cicatrices y alimentan tu fuego—no parches, sino un camino implacable para reclamar esperanza, romper límites y desatar la fuerza inquebrantable dentro de ti.",
  about_text_4: "Esto es Function in Motion: Donde el dolor se rinde al poder. Donde el movimiento se convierte en maestría. Tu triunfo comienza ahora.",

  // Roadmap/Process Section
  roadmap_title: "Hoja de Ruta",
  roadmap_1_title: "EVALUACIÓN",
  roadmap_1_text: "Empezamos escuchando su historia y entendiendo lo que realmente está sucediendo. A través de una evaluación exhaustiva, identificamos la causa raíz de su dolor o limitación, no solo los síntomas.",
  roadmap_2_title: "PLAN DE ATENCIÓN INDIVIDUALIZADO/FIJACIÓN DE OBJETIVOS",
  roadmap_2_text: "Juntos, establecemos objetivos claros, realistas y alcanzables que son importantes para usted. Luego creamos un plan personalizado que se ajusta a su estilo de vida, edad, limitaciones físicas, fortalezas y horario para ayudarlo a alcanzar esos objetivos.",
  roadmap_3_title: "COLABORACIÓN",
  roadmap_3_text: "Juntos, ejecutaremos su plan. Su terapeuta proporciona las herramientas y el conocimiento, pero la rehabilitación real ocurre en casa, donde usted pone en práctica lo que ha aprendido. Lo guiamos, pero su compromiso es lo que marca la diferencia.",
  roadmap_4_title: "SEGUIMIENTO DEL PROGRESO",
  roadmap_4_text: "La recuperación no es lineal, y lo entendemos. Evaluamos regularmente cómo está progresando, celebramos los logros y ajustamos su plan cuando es necesario. Si algo no funciona, cambiamos de dirección. Si está superando sus objetivos, subimos el listón. Nos mantenemos flexibles y receptivos porque su cuerpo y su viaje son únicos.",
  roadmap_5_title: "REEVALUACIÓN",
  roadmap_5_text: "Evaluamos si los objetivos que establecimos juntos se han logrado. Si no se han cumplido, crearemos un nuevo plan para que los alcance. Si lo han hecho, enhorabuena, se lo ha ganado. Este punto de control asegura que esté listo para avanzar o equipado con un camino claro para seguir progresando.",
  roadmap_6_title: "SOPORTE CONTINUO Y PREVENCIÓN",
  roadmap_6_text: "Antes de irse, lo equipamos con el conocimiento y las herramientas para mantener su progreso y prevenir futuras lesiones. Y si alguna vez nos necesita de nuevo, estamos a solo una llamada de distancia.",

  // Team/Services Section
  title_what_we_do: "Lo Que Hacemos",
  service_1_title: "Rehabilitación Post-Quirúrgica",
  service_1_text: "Recupérese más fuerte después de la cirugía",
  service_2_title: "Rehabilitación de Lesiones Deportivas",
  service_2_text: "Vuelva a su deporte, de forma segura",
  service_3_title: "Manejo del Dolor Crónico",
  service_3_text: "Vaya más allá de solo sobrellevarlo",
  service_4_title: "Terapia de Ondas de Choque Stemwave",
  service_4_text: "Para el dolor persistente de tendones y tejidos blandos",
  service_5_title: "Cinta de Correr Antigravedad Alter-G",
  service_5_text: "Retorno de bajo impacto a caminar y correr",
  service_6_title: "Entrenamiento de Marcha y Equilibrio",
  service_6_text: "Mejore la estabilidad y prevenga caídas",
  service_7_title: "Rendimiento y Retorno al Deporte",
  service_7_text: "Entrene para rendir, no solo para sanar",
  service_8_title: "Rehabilitación de Columna y Postura",
  service_8_text: "Cuidado centrado en el cuello, la espalda y el tronco",
  service_9_title: "Rehabilitación de Lesiones Laborales",
  service_9_text: "Vuelva al trabajo de forma segura y más fuerte",

  // Showcase/Review Section
  title_what_they_say: "Lo Que Dicen de Nosotros",
  reviewed_by: "Opinión de",
  rating: "Calificación",
  review_1_text: "Vic y su personal han sido una bendición durante este momento difícil. Me estoy recuperando de una fractura de meseta tibial izquierda. He visto un progreso inmenso. Sé que seguiré mejorando gracias a la atención y el cuidado que me ha brindado el personal.",
  review_5_text: 'He estado haciendo Fisioterapia durante un año y medio debido a que tengo Movilidad Limitada sin resultados. Decidí probar Function In Motion y no me arrepentí de mi elección. Gracias a Vic y a su personal atento, considerado e increíble, mi movilidad ha mejorado considerablemente. Realmente hacen honor a su nombre "Function In Motion".',
  review_6_text: "Hola, mi nombre es Carolyn, y solo me gustaría decir que me sorprendió lo educados y atentos que son Vic y su personal con sus clientes. Se toma tiempo para responder todas sus preguntas e inquietudes, ¡sí, recomendaría encarecidamente a cualquiera que esté interesado en encontrar un buen fisioterapeuta que venga a Function in Motion y quedarían más que satisfechos!",
  review_10_text: "Hacen todo lo posible para satisfacer sus necesidades y hacerle sentir visto y apoyado en cada visita.",

  // FAQ Section
  faq_heading: "Preguntas Frecuentes",
  faq_referral_q: "¿Necesito una remisión de mi proveedor?",
  faq_referral_a: "Sí. Se requiere una remisión a menos que su seguro sea HIP, GHI, o esté pagando usted mismo la visita. Si no está seguro de lo que requiere su plan, podemos ayudarle a confirmarlo antes de su primera cita.",
  faq_sessions_q: "¿Cuánto duran las sesiones?",
  faq_sessions_a: "Las sesiones suelen durar 45–60 minutos, lo que nos da tiempo real para trabajar con usted individualmente y abordar lo que está sucediendo.",
  faq_first_visit_expect_q: "¿Qué debo esperar en mi primera cita de fisioterapia?",
  faq_first_visit_expect_a: "Su terapeuta tomará su historial médico, discutirá sus síntomas, realizará una evaluación física y creará un plan de tratamiento personalizado. Usted puede también recibir su primer tratamiento el mismo día.",
  faq_hurt_q: "¿Dolerá la fisioterapia?",
  faq_hurt_a: "Algunas molestias durante el tratamiento son normales—la curación no siempre es fácil. Pero nunca lo forzaremos más allá de lo que sea seguro o productivo. Estamos aquí para ayudarle a sanar, no para empeorar las cosas.",
  faq_insurance_q: "¿Mi seguro cubrirá esto?",
  faq_insurance_a: "La mayoría de los planes de seguro cubren la fisioterapia, pero la cobertura varía. Le ayudaremos a entender sus beneficios y trabajaremos con usted en las opciones de pago.",
  faq_bring_first_q: "¿Qué debo llevar a mi primera visita?",
  faq_bring_first_a: "Una remisión (a menos que su seguro sea HIP, GHI, o esté pagando usted mismo la visita), su tarjeta de seguro, identificación con foto, lista de medicamentos, cualquier registro médico o informe de imágenes relevante, y ropa cómoda.",
  faq_cancel_q: "¿Qué pasa si necesito cancelar mi cita?",
  faq_cancel_a: "Por favor, avísenos lo antes posible si no puede venir. Esto nos permite dar su tiempo de cita a otro paciente que lo necesite.",
  faq_pain_return_q: "¿Qué pasa si mi dolor regresa después del tratamiento?",
  faq_pain_return_a: "No solo solucionamos el problema, le enseñamos cómo prevenir que vuelva a suceder. Y si algo surge más adelante, siempre estamos aquí.",
  faq_exercises_q: "¿Necesito seguir haciendo ejercicios después de que termine la terapia?",
  faq_exercises_a: "Sí. Los ejercicios y hábitos que construimos juntos no son solo para la recuperación, son para mantenerle fuerte y sin dolor a largo plazo. Le daremos un plan de mantenimiento que sea realista y sostenible para su vida.",

  // Contact Form Section
  contact_heading: "Deje un Mensaje",
  contact_subtitle: "¿Tiene una pregunta sobre su condición o seguro? Envíenos un mensaje rápido y le responderemos lo antes posible.",
  contact_name_label: "Su Nombre",
  contact_email_label: "Su Correo Electrónico",
  contact_message_label: "Su Mensaje",
  contact_send_btn: "Enviar Mensaje",
  contact_success_message: "¡Gracias por su mensaje! Nos pondremos en contacto en breve.",
  contact_error_message: "¡Ups! Hubo un problema al enviar su formulario.",

  // Insurance Section
  title_insurances_accepted: "Seguros Aceptados",
  insurance_subtitle: "Trabajamos con las principales aseguradoras para que sus pacientes puedan centrarse en la curación, no en el papeleo.",

  // Footer & Banner
  banner_title_1: "Recuperación real. Resultados reales. Vida real.",
  banner_title_2: "¡Únete a Nosotros!",
  footer_phone: "Teléfono:",
  footer_hours: "Horario",
  footer_hours_mf: "Lun–Vie: 8:30am – 5:00pm",
  footer_hours_sat: "Sáb: 8:30am – 12:00pm",
  footer_hours_sun: "Dom: Cerrado",
  footer_all_rights_reserved: "Todos los derechos reservados.",
  footer_made_by: "Hecho con ❤️ por",
};